import React, { useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import "../../newstyle.css";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../../../Components/SearchBox";
import { Formik } from "formik";
import { ProductSearchBarInitialValues } from "../../constant";
import { useQuery } from "@tanstack/react-query";
import { GetProductList, ProductStatusChange } from "../../../../Api/product";
import { useMutateDeleteProduct } from "../../hooks/useApiHook";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../../Utils/SweetAlert";
import Pagination from "../../../../Utils";
import { IoEye } from "react-icons/io5";
import CategoryFilter from "../Filter/CategoryFilter";
import { EditButton, DeleteButton, AddButton } from "../../../../Components";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
const ProductsList = () => {
  const navigate = useNavigate();
  const formRef = useRef();

  const [selectedCategory, setSelectedCategory] = useState(null);



  /**
   * Api
   */
  const deleteProduct = useMutateDeleteProduct();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const {
    isFetching: isProductLoading,
    data: productList,
    refetch,
  } = useQuery({
    queryKey: ["get-product-list", page, limit, selectedCategory],
    queryFn: () => {
      const params = {
        page: page === 0 ? 1 : page + 1,
        limit,
        search: formRef?.current?.values?.search,
        categoryIds: selectedCategory,
      };

      return GetProductList(params);
    },
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server error.");
    },
  });

  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
  };

  const handleLimitChange = async (event) => {
    setPage(0);
    setLimit(parseInt(event.target.value, 10));
  };

  const handleStatusChange = async (values) => {
    Confirmation(
      values?.status === false
        ? "Are you sure you want to active product status ?"
        : "Are you sure you want to inactive product status?"
    ).then(async (deleteConfirm) => {
      if (deleteConfirm.isConfirmed) {
        await ProductStatusChange({ id: values.id })
          .then((res) => {
            SuccessToast(res?.data?.message || "status Updated");
            refetch();
          })
          .catch((err) => {
            if (typeof err?.response?.data?.message !== "undefined") {
              ErrorToast(err?.response?.data?.message || "Server Error!!");
            } else {
              ErrorToast(err?.message || "Server Error!!");
            }
          });
      }
    });
  };
  return (
    <>
      <Helmet>
        <title>OVE | Admin Products</title>
      </Helmet>

      <div className="page-wrapper admin-user">
        <div className="content container-fluid">
          <div className="admin-wrapper">
            {/* <div className="page-header">
              <div className="col">
                <h1 className="page-title">Product</h1>
              </div>
              <div className="col-12 col-md-3 col-lg-5 px-2">
                <Formik
                  initialValues={ProductSearchBarInitialValues}
                  innerRef={formRef}
                >
                  {({ values, setFieldValue }) => {
                    const filterStyles = {
                      option: (styles, { isDisabled }) => ({
                        ...styles,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        marginTop: "0px",
                        marginBottom: "0px",
                      }),
                      control: (styles, state) => ({
                        ...styles,
                        border: "2px solid #00000061",
                        borderColor: state.isFocused ? "#AD5ADC" : "#F7F5F5",
                        boxShadow: state.isFocused ? "0 0 0 1px #AD5ADC" : "none",
                        borderRadius: "20px",
                        minHeight: 42,
                        height: 42,
                        paddingLeft: 6,
                      }),
                      valueContainer: (styles) => ({
                        ...styles,
                        paddingTop: 0,
                        paddingBottom: 0,
                        height: 38,
                      }),
                      input: (styles) => ({
                        ...styles,
                        margin: 0,
                        padding: 0,
                      }),
                      placeholder: (styles) => ({
                        ...styles,
                        color: "#6b6b6b",
                      }),
                      singleValue: (styles) => ({
                        ...styles,
                        color: "#000",
                        fontWeight: 400,
                      }),
                      menu: (styles) => ({
                        ...styles,
                        borderRadius: "20px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }),
                    };
                    return (
                      <div className="d-flex gap-2">
                        {/* <div className="w-100">
                          <PhaseSelect
                            isMulti
                            value={values.phases}
                            placeholder="Filter Phases"
                            onChange={(phaseValues) => {
                              const updatedPhases = Array.isArray(phaseValues)
                                ? phaseValues
                                : [];
                              setFieldValue("phases", updatedPhases);
                              setPhaseFilters(updatedPhases);
                              setPage(0);
                            }}
                            selectStyles={filterStyles}
                            closeMenuOnSelect={false}
                          />
                        </div> */}
            {/* <div className="w-100">
                          <CategoryFilter
                            onCategoryChange={(categoryId) => {
                              setSelectedCategory(categoryId);
                              setPage(0);
                            }}
                          />
                        </div> *
                        <div className="w-100">
                          <SearchBox refetch={refetch} setPage={setPage} />
                        </div>
                      </div>
                    );
                  }}
                </Formik>
              </div>
              <div>
                <AddButton
                  to="/admin/add-product"
                  permission="create-product"
                />
              </div>
            </div> */}
            <div className="page-header">
              <div className="w-100">
                <div className="d-flex w-100">
                  <div className="col">
                    <h1 className="page-title">Product</h1>
                  </div>
                  <div className="col-12 col-md-3 col-lg-2 px-2">
                    <Formik
                      initialValues={ProductSearchBarInitialValues}
                      innerRef={formRef}
                    >
                      {() => {
                        return (
                          <form>
                            <SearchBox refetch={refetch} setPage={setPage} />
                          </form>
                        );
                      }}
                    </Formik>
                  </div>
                  <div className="col-12 col-md-4 col-xl-3 px-2">
                    <CategoryFilter onCategoryChange={setSelectedCategory} />
                  </div>
                  <div>
                    <AddButton
                      to="/admin/add-product"
                      permission="create-product"
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end w-100 mt-1">
                  <Formik
                    initialValues={ProductSearchBarInitialValues}
                    innerRef={formRef}
                  >
                    {({ values, setFieldValue }) => {
                      return null;
                    }}
                  </Formik>
                </div>
              </div>
            </div>
            <div className="col-sm-12 table-width">
              <div className="cards-table card-table">
                <div className="card-body">
                  <div className="table-responsive category-table custom-pagination table-no-padding">
                    <table className="table datatable table-manager mb-0" style={{ width: '100%' }}>
                      <thead className="thead-light">
                        <tr>
                          <th className="text-start" style={{ width: '25%' }}>Name</th>
                          <th className="text-start" style={{ width: '25%' }}>Parent Category</th>
                          <th className="text-start" style={{ width: '20%' }}>Category</th>
                          <th className="text-center" style={{ width: '15%' }}>Status</th>
                          <th className="text-center col-action" style={{ width: '15%' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isProductLoading && (
                          <tr>
                            <td align="center" colSpan={5}>
                              <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border loader-theme" role="status" />
                              </div>
                            </td>
                          </tr>
                        )}
                        {!isProductLoading && productList !== undefined && (
                          <>
                            {productList?.data?.data.map((item, index) => {
                              return (
                                <tr key={index} className="table disable-row">
                                  <td className="text-start">
                                    <Tooltip title={item.name} placement="top">
                                      <span className="category-cell-ellipsis">
                                        {item.name?.length >= 45
                                          ? item.name.substring(0, 40) + "..."
                                          : item.name || "-"}
                                      </span>
                                    </Tooltip>
                                  </td>
                                  <td className="text-start">
                                    <span className="category-cell-ellipsis">{item?.category?.parentCategory?.name || "-"}</span>
                                  </td>
                                  <td className="text-start">
                                    <span className="category-cell-ellipsis">{item?.category?.name || "-"}</span>
                                  </td>

                                  <td className="text-center">
                                    {item?.status == true ? (
                                      <button
                                        onClick={() =>
                                          handleStatusChange({
                                            id: item?._id,
                                            status:
                                              item?.status === true
                                                ? false
                                                : true,
                                          })
                                        }
                                        className="active-btn btn-success"
                                        disabled={
                                          item?.role === "superadmin"
                                            ? true
                                            : false
                                        }
                                      >
                                        Active
                                      </button>
                                    ) : (
                                      (
                                        <button
                                          onClick={() =>
                                            handleStatusChange({
                                              id: item?._id,
                                              status:
                                                item?.status === true
                                                  ? false
                                                  : true,
                                            })
                                          }
                                          className="inactive-btn btn-danger"
                                          disabled={
                                            item?.role === "superadmin"
                                              ? true
                                              : false
                                          }
                                        >
                                          Inactive
                                        </button>
                                      ) || "-"
                                    )}
                                  </td>
                                  <td className="category-td-padding-remove col-action text-center main-action-button">
                                    <EditButton
                                      to="/admin/edit-product"
                                      state={{ id: item?._id }}
                                      permission="edit-product"
                                    />
                                    <DeleteButton
                                      onDelete={() => {
                                        Confirmation("Are you sure you want to delete product?").then((result) => {
                                          if (result.isConfirmed) {
                                            deleteProduct.mutate(item?._id, {
                                              onSuccess: (response) => {
                                                SuccessToast(response?.message || "Delete successful.");
                                                refetch();
                                              },
                                              onError: (error) => {
                                                ErrorToast(error?.response?.data?.message || "Server error.");
                                              },
                                            });
                                          }
                                        });
                                      }}
                                      permission="delete-product"
                                    />
                                    <Tooltip
                                      title="View"
                                      className="btn btn-sm btn-white text-success insight-stickey-actions-btn"
                                      onClick={() =>
                                        navigate("/admin/product-detail", {
                                          state: { id: item?._id },
                                        })
                                      }
                                    >
                                      <IconButton>
                                        <IoEye
                                          className="text-secondary icon-color p-0"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </td>
                                </tr>
                              );
                            })}
                            {productList?.data?.data?.length === 0 && (
                              <tr>
                                <td className="text-center" colSpan={5}>
                                  No Records Found.
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <Pagination
              totalItem={productList?.data?.totalRecords || 0}
              itemsPerPage={limit}
              page={
                !productList?.data?.totalRecords ||
                  productList?.data?.totalRecords <= 0
                  ? 0
                  : page
              }
              handleChangePage={handlePageChange}
              handleChangeRowsPerPage={handleLimitChange}
              colSpan={5}
            />
          </div>
        </div>
      </div >
    </>
  );
};
export default ProductsList;
